import { ChangeDetectorRef, Component, NgZone } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { LoaderService } from '../loader.service';
import { Event } from '@angular/router';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { FooterComponent } from '../../components/footer/footer.component';
import { HeaderComponent } from '../../components/header/header.component';
@Component({
  selector: 'app-loader',
  standalone: true,
  imports: [CommonModule, HeaderComponent, FooterComponent, RouterModule, ReactiveFormsModule],
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.css']
})
export class LoaderComponent {
  loadingprogress: boolean = false
  progressValue: number = 0;
  stopProgress: boolean = false;;
  progressColor: string = '';
  // progressTimer: NodeJS.Timeout;
  width: number = 10;
  constructor(
    private loaderService: LoaderService,
    private router: Router,
    private cdr: ChangeDetectorRef,
    private ngZone: NgZone
  ) {
    this.loaderService.isLoading.subscribe(v => {
      this.ngZone.run(() => {
        this.loadingprogress = v;
        this.cdr.detectChanges();
      });
    });

    router.events.subscribe((event: Event) => {
      this.navigationObserver(event);
    });

    router.events.subscribe((event: Event) => {
      this.navigationObserver(event);
    });
  }

  ngOnInit() {
  }
  private loading(): void {
    if (this.progressValue >= window.innerHeight || this.stopProgress) {
      // clearInterval(this.progressTimer);
      this.progressValue = 0;
    } else {
      this.progressValue++;
    }
    document.getElementById("divbar")!.style.width = this.progressValue + "px"
  }

  private navigationObserver(event: Event): void {

    // if (event instanceof NavigationStart) {
    //   this.progressTimer = setInterval(() => {
    //     this.loading();
    //   }, 100);
    // }
    // if (event instanceof NavigationEnd) {
    //   this.progressValue = window.innerWidth;
    //   this.stopProgress = true;
    // }
  }
}
